import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_e1a30c380d: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_e1a30c380d",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Unique Finds Not Sold on Amazon",
  description:
    "Exclusive and hard-to-find items not available on Amazon, perfectly suited for a pop-up looking to offer shoppers truly unique and distinctive gifts.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/1d163fd6f695695e5a5bd4228c9735ca43c81e636a3b19b2440d662c6d83dd3b.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/1d163fd6f695695e5a5bd4228c9735ca43c81e636a3b19b2440d662c6d83dd3b.jpeg",
    "https://cdn.faire.com/fastly/0906fab7e96152e1eff6065bbf1980d17ae1c62c802a668f313bf39be7f582e9.jpeg",
    "https://cdn.faire.com/fastly/595045ed720f6fa60d642a9ee2f324e20f40e0529cd6edb615d29471a985fe99.jpeg",
    "https://cdn.faire.com/fastly/f141ad049c8a1a83bbb58f462e0c94c22396d5bf4a03d8db5b124c063094239c.jpeg",
    "https://cdn.faire.com/fastly/7ce89e5addffcd71ae85663e5ebcca2e0b3786c1aa25315bb89331d90867b5a0.jpeg",
    "https://cdn.faire.com/fastly/60563fc19877a979b09ad7155991cded1fe0b86829a30d8c1a7a45109a035659.jpeg",
  ],
  itemCount: 55,
  source: "eric_themes_ideas",
  teaser: "thi_e1a30c380d",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
